export default __webpack_public_path__ + "static/media/android.0a94e4ea.svg";